import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFacilityAllocation from './facility-allocation.reducer';

export const selectFacilityAllocationState = createFeatureSelector<
    fromFacilityAllocation.State
>(fromFacilityAllocation.facilityAllocationsFeatureKey);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromFacilityAllocation.adapter.getSelectors(selectFacilityAllocationState);
export const selectFacilityAllocationTypes = createSelector(
    selectFacilityAllocationState,
    state => state.facilityAllocationTypes
);
